// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"MessengerHeader_HeaderContainer__2fIxG","btnComposeMessage":"MessengerHeader_btnComposeMessage__3-ppA"};